import { render, staticRenderFns } from "./MessageFlow.vue?vue&type=template&id=4821636f&scoped=true&"
import script from "./MessageFlow.vue?vue&type=script&lang=js&"
export * from "./MessageFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821636f",
  null
  
)

export default component.exports